document.addEventListener("DOMContentLoaded", function () {
    var searchTypeSelector = document.getElementById("search-type-selector");
    var optionLinks = document.querySelectorAll("#header-internal-search .dropdown li a");

    optionLinks.forEach(function (link) {
        link.addEventListener("click", function () {
            var searchOptionInput = document.getElementById("searchOption");
            if (searchOptionInput) {
                searchOptionInput.value = this.getAttribute("data-value") || "";
            }
        });
    });

    var searchIcon = document.getElementById("internal-search");
    var searchInput = document.getElementById("input-key-search");
    var searchForm = document.getElementById("internalSearchForm");
    var hiddenSearchKey = document.getElementById("searchKey");
    var suggestionList = document.getElementById("internal-search-suggestions");
    var loadingSpinner = document.getElementById("internal-search-loading-spinner");
    var lastRequestId = 0;
    var activeSuggestionIndex = -1;
    var suggestionsTimeout = null;
    var suggestionOriginalParent = null;
    var suggestionOriginalNextSibling = null;
    var currentAbortController = null;

    function shouldUseSuggestionsPortal() {
        return window.matchMedia && window.matchMedia("(max-width: 639px)").matches;
    }

    function ensureSuggestionsPlacement() {
        if (!suggestionList) {
            return;
        }

        // Mobile internal navigation creates stacking contexts above the header.
        // Rendering suggestions under document.body avoids those contexts and keeps the list visible.
        if (shouldUseSuggestionsPortal()) {
            if (suggestionList.parentNode !== document.body) {
                suggestionOriginalParent = suggestionList.parentNode;
                suggestionOriginalNextSibling = suggestionList.nextSibling;
                document.body.appendChild(suggestionList);
            }

            suggestionList.classList.add("internal-search-suggestions--portal");
            return;
        }

        suggestionList.classList.remove("internal-search-suggestions--portal");

        if (suggestionOriginalParent && suggestionList.parentNode === document.body) {
            if (suggestionOriginalNextSibling && suggestionOriginalNextSibling.parentNode === suggestionOriginalParent) {
                suggestionOriginalParent.insertBefore(suggestionList, suggestionOriginalNextSibling);
            } else {
                suggestionOriginalParent.appendChild(suggestionList);
            }
        }
    }

    function updateSuggestionsPosition() {
        if (!suggestionList || !searchInput || !shouldUseSuggestionsPortal()) {
            return;
        }

        var rect = searchInput.getBoundingClientRect();
        suggestionList.style.top = (Math.round(rect.bottom) + 5) + "px";
        suggestionList.style.left = Math.round(rect.left) + "px";
        suggestionList.style.width = Math.round(rect.width) + "px";
        suggestionList.style.right = "auto";
    }

    function setSuggestionsLoading(isLoading) {
        if (loadingSpinner) {
            loadingSpinner.hidden = !isLoading;
        }

        if (searchInput) {
            searchInput.classList.toggle("is-loading", isLoading);
        }
    }

    function getSuggestionItems() {
        if (!suggestionList) {
            return [];
        }

        return Array.prototype.slice.call(suggestionList.querySelectorAll(".internal-search-suggestion-item"));
    }

    function setActiveSuggestion(index) {
        var items = getSuggestionItems();
        if (!items.length) {
            activeSuggestionIndex = -1;
            return;
        }

        if (index < 0) {
            index = items.length - 1;
        }

        if (index >= items.length) {
            index = 0;
        }

        items.forEach(function (item) {
            item.classList.remove("is-active");
            item.setAttribute("aria-selected", "false");
        });

        activeSuggestionIndex = index;
        items[activeSuggestionIndex].classList.add("is-active");
        items[activeSuggestionIndex].setAttribute("aria-selected", "true");
        items[activeSuggestionIndex].scrollIntoView({ block: "nearest" });
    }

    function selectSuggestion(item) {
        if (!item || !searchInput) {
            return;
        }

        searchInput.value = item.getAttribute("data-key") || item.textContent || "";
        hideSuggestions();
        submitSearch();
    }

    function hideSuggestions() {
        if (!suggestionList) {
            return;
        }

        suggestionList.innerHTML = "";
        suggestionList.hidden = true;
        activeSuggestionIndex = -1;
        setSuggestionsLoading(false);

        if (shouldUseSuggestionsPortal()) {
            suggestionList.style.top = "";
            suggestionList.style.left = "";
            suggestionList.style.width = "";
            suggestionList.style.right = "";
        }
    }

    function submitSearch() {
        if (!searchInput || !searchForm) {
            return;
        }

        var searchKey = (searchInput.value || "").trim();
        if (searchKey === "") {
            return;
        }

        if (hiddenSearchKey) {
            hiddenSearchKey.value = searchKey;
        }

        hideSuggestions();
        searchForm.submit();
    }

    function renderSuggestions(items) {
        if (!suggestionList) {
            return;
        }

        ensureSuggestionsPlacement();
        suggestionList.innerHTML = "";

        if (!items || items.length === 0) {
            suggestionList.hidden = true;
            return;
        }

        items.forEach(function (item) {
            var listItem = document.createElement("li");
            listItem.className = "internal-search-suggestion-item";
            listItem.textContent = item.key + " - " + item.label;
            listItem.setAttribute("data-key", item.key);
            listItem.setAttribute("role", "option");
            listItem.setAttribute("aria-selected", "false");
            listItem.addEventListener("mouseenter", function () {
                var itemsInList = getSuggestionItems();
                var index = itemsInList.indexOf(listItem);
                if (index > -1) {
                    setActiveSuggestion(index);
                }
            });
            listItem.addEventListener("mousedown", function (event) {
                event.preventDefault();
                selectSuggestion(listItem);
            });

            suggestionList.appendChild(listItem);
        });

        suggestionList.hidden = false;
        activeSuggestionIndex = -1;
        updateSuggestionsPosition();
    }

    function getSelectedSearchType() {
        if (!searchTypeSelector) {
            return "customer";
        }

        return searchTypeSelector.value || "customer";
    }

    // Cache to store suggestions
    var suggestionsCache = new Map();
    var suggestionsCacheBytes = 0;
    var SUGGESTIONS_CACHE_MAX_BYTES = 3 * 1024 * 1024; // Maximum cache size: 3 MB

    // Calculate the size of a cache entry
    function getCacheEntrySize(value) {
        return new Blob([JSON.stringify(value)]).size;
    }

    // Add or update an entry in the cache
    function setCacheEntry(key, value) {
        // Remove existing entry size from total if key exists
        if (suggestionsCache.has(key)) {
            suggestionsCacheBytes -= getCacheEntrySize(suggestionsCache.get(key));
            suggestionsCache.delete(key);
        }

        var entrySize = getCacheEntrySize(value);

        // Ensure cache size does not exceed the maximum limit
        while (suggestionsCacheBytes + entrySize > SUGGESTIONS_CACHE_MAX_BYTES && suggestionsCache.size > 0) {
            var firstKey = suggestionsCache.keys().next().value; // Get the first key in the cache
            suggestionsCacheBytes -= getCacheEntrySize(suggestionsCache.get(firstKey));
            suggestionsCache.delete(firstKey); // Remove the oldest entry
        }

        // Add the new entry to the cache
        suggestionsCache.set(key, value);
        suggestionsCacheBytes += entrySize;
    }

    async function fetchSuggestions(query) {
        lastRequestId += 1;
        var requestId = lastRequestId;
        var searchType = getSelectedSearchType();
        var cacheKey = searchType + ":" + query;

        if (suggestionsCache.has(cacheKey)) {
            if (requestId !== lastRequestId) {
                return;
            }
            setSuggestionsLoading(false);
            renderSuggestions(suggestionsCache.get(cacheKey));
            return;
        }

        if (currentAbortController) {
            currentAbortController.abort();
        }
        currentAbortController = new AbortController();
        var signal = currentAbortController.signal;

        setSuggestionsLoading(true);

        try {
            var response = await fetch("/api/internal-portal/search-suggestions?query=" + encodeURIComponent(query) + "&searchType=" + encodeURIComponent(searchType), {
                method: "GET",
                headers: {
                    "Accept": "application/json"
                },
                signal: signal
            });

            if (!response.ok) {
                throw new Error("Failed to load suggestions");
            }

            var data = await response.json();
            if (requestId !== lastRequestId) {
                return;
            }

            var suggestions = Array.isArray(data) ? data : [];
            setCacheEntry(cacheKey, suggestions);
            renderSuggestions(suggestions);
        } catch (err) {
            if (err.name === "AbortError") {
                return;
            }
            if (requestId === lastRequestId) {
                hideSuggestions();
            }
        } finally {
            if (requestId === lastRequestId) {
                setSuggestionsLoading(false);
                currentAbortController = null;
            }
        }
    }

    if (searchInput && suggestionList) {
        ensureSuggestionsPlacement();
        suggestionList.setAttribute("role", "listbox");

        searchInput.addEventListener("input", function () {
            var query = (searchInput.value || "").trim();

            // Clear previous timeout
            if (suggestionsTimeout) {
                clearTimeout(suggestionsTimeout);
            }

            if (query.length < 3) {
                hideSuggestions();
                return;
            }

            // Debounce: wait 200ms before fetching suggestions
            suggestionsTimeout = setTimeout(function () {
                fetchSuggestions(query);
            }, 200);
        });

        searchInput.addEventListener("keydown", function (event) {
            var items = getSuggestionItems();
            var hasVisibleSuggestions = !suggestionList.hidden && items.length > 0;

            if (event.key === "ArrowDown" && hasVisibleSuggestions) {
                event.preventDefault();
                setActiveSuggestion(activeSuggestionIndex + 1);
                return;
            }

            if (event.key === "ArrowUp" && hasVisibleSuggestions) {
                event.preventDefault();
                setActiveSuggestion(activeSuggestionIndex - 1);
                return;
            }

            if (event.key === "Enter") {
                event.preventDefault();

                if (hasVisibleSuggestions && activeSuggestionIndex > -1) {
                    selectSuggestion(items[activeSuggestionIndex]);
                    return;
                }

                submitSearch();
            }

            if (event.key === "Escape") {
                hideSuggestions();
            }
        });

        searchInput.addEventListener("blur", function () {
            window.setTimeout(hideSuggestions, 150);
        });

        if (searchTypeSelector) {
            searchTypeSelector.addEventListener("change", function () {
                var query = (searchInput.value || "").trim();

                if (query.length < 3) {
                    lastRequestId += 1;
                    hideSuggestions();
                    return;
                }

                fetchSuggestions(query);
            });
        }

        window.addEventListener("resize", function () {
            ensureSuggestionsPlacement();
            if (!suggestionList.hidden) {
                updateSuggestionsPosition();
            }
        });

        window.addEventListener("scroll", function () {
            if (!suggestionList.hidden) {
                updateSuggestionsPosition();
            }
        }, true);
    }

    if (searchIcon) {
        searchIcon.addEventListener("click", submitSearch);
    }

    var closeButton = document.querySelector("header.internal-page a.close-btn");
    if (closeButton) {
        closeButton.addEventListener("click", async function () {
            var customerPopup = closeButton.closest("#customer-popup");
            if (!customerPopup || !customerPopup.classList.contains("open")) {
                return;
            }

            try {
                var response = await fetch("/api/internal-portal/close-customer-session", {
                    method: "GET",
                    headers: {
                        "Accept": "application/json"
                    },
                    cache: "no-store"
                });

                if (!response.ok) {
                    throw new Error("Failed to close customer session");
                }

                var data = await response.json();
                if (!data) {
                    return;
                }

                var currentUrl = new URL(window.location.href);
                // The user page requires userName, so closing the customer session must navigate home instead.
                // "user" is hardcoded for the user page controller
                if (/(?:^|\/)user(?:\/|$)/i.test(currentUrl.pathname)) {
                    window.location.assign("/");
                    return;
                }

                if (currentUrl.search) {
                    var cleanUrl = new URL(currentUrl.origin + currentUrl.pathname);
                    window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search);
                }

                window.location.reload();
            } catch {
            }
        });
    }
});
